Postlogin.Lesson = (function (my) {
    my.Matching = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container = null;
        const numberOfOptions = Object.keys(me.options).length;
        let numberMatched = 0;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            const leftCollection = $('<div></div>').addClass('collection collection-1');
            const rightCollection = $('<div></div>').addClass('collection collection-2');

            $.each(me.options, (i, option) => {
                // add left item
                const leftOptionItem = $('<div></div>').addClass(`item option-${option.activity_option_id}`);

                me.makeDraggable(leftOptionItem);
                me.makeDroppable(leftOptionItem, option.activity_option_id);

                let wrapper = $('<div></div>').addClass('wrapper');
                let optionText;
                if (option.answer_image) {
                    leftOptionItem.addClass('has-image');
                    wrapper.css('backgroundImage', `url(${option.answer_image})`);
                    if (option.answer) {
                        optionText = $(`<div class="option-text"><span>${option.answer}</span></div>`);
                        if (option.answer.length > 90) {
                            optionText.addClass('smaller-text-1');
                        }
                        wrapper.append(optionText);
                    }
                } else {
                    leftOptionItem.addClass('text-only');
                    if (option.answer) {
                        optionText = $(`<div class="option-text"><span>${option.answer}</span></div>`);
                        if (option.answer.length > 90) {
                            optionText.addClass('smaller-text-1');
                        }
                        wrapper.append(optionText);
                    }
                }

                if (option.answer_audio) {
                    leftOptionItem.addClass('has-audio');
                    leftOptionItem.attr('data-audio', option.answer_audio);
                }

                leftOptionItem.append(wrapper);

                const leftItems = leftCollection.find('.item');
                if (me.activity_data.shuffled && leftItems.length) {
                    if (Math.floor(Math.random() * 2)) {
                        leftItems.eq(Math.floor(Math.random() * leftItems.length)).after(leftOptionItem);
                    } else {
                        leftItems.eq(Math.floor(Math.random() * leftItems.length)).before(leftOptionItem);
                    }
                } else {
                    leftCollection.append(leftOptionItem);
                }

                // add right item
                const rightOptionItem = $('<div></div>').addClass(`item option-${option.activity_option_id}`);

                me.makeDraggable(rightOptionItem);
                me.makeDroppable(rightOptionItem, option.activity_option_id);

                wrapper = $('<div></div>').addClass('wrapper');
                if (option.hint_image) {
                    rightOptionItem.addClass('has-image');
                    wrapper.css('backgroundImage', `url(${option.hint_image})`);
                    if (option.hint) {
                        wrapper.append(`<div class="option-text"><span>${option.hint}</span></div>`);
                    }
                } else {
                    rightOptionItem.addClass('text-only');
                    if (option.hint) {
                        wrapper.append(`<div class="option-text"><span>${option.hint}</span></div>`);
                    }
                }
                if (option.hint_audio) {
                    rightOptionItem.addClass('has-audio');
                    rightOptionItem.attr('data-audio', option.hint_audio);
                }
                rightOptionItem.append(wrapper);

                // randomize order of items (if shuffled == 1)
                const rightItems = rightCollection.find('.item');
                if (me.activity_data.shuffled && rightItems.length) {
                    if (Math.floor(Math.random() * 2)) {
                        rightItems.eq(Math.floor(Math.random() * rightItems.length)).after(rightOptionItem);
                    } else {
                        rightItems.eq(Math.floor(Math.random() * rightItems.length)).before(rightOptionItem);
                    }
                } else {
                    rightCollection.append(rightOptionItem);
                }
            });

            segmentContainer.append(leftCollection);
            segmentContainer.append(rightCollection);
            segmentContainer.append('<div class="matching-arrow" id="right">');
            segmentContainer.append('<div class="matching-arrow" id="left">');

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.makeDraggable = function (optionItem) {
            optionItem.draggable({
                cursor: 'grabbing',
                containment: `#${containerId}`,
                scroll: false,
                start() {
                    Postlogin.Lesson.setDragging(true);
                    Postlogin.Lesson.playSoundEffect('pick_up');
                    $(this).css('cursor', 'grabbing');
                    $(this).siblings('.item').addClass('smaller');
                    $(this).parent().siblings('.collection').find('.item')
                        .addClass('larger');
                    if ($(this).parent().hasClass('collection-1')) {
                        container.find('.matching-arrow#right').addClass('highlighted');
                        container.find('.matching-arrow#left').addClass('hidden');
                    } else {
                        container.find('.matching-arrow#left').addClass('highlighted');
                        container.find('.matching-arrow#right').addClass('hidden');
                    }
                },
                stop() {
                    Postlogin.Lesson.setDragging(false);
                    $(container).find('.collection .item').removeClass('larger smaller');
                    container.find('.matching-arrow').removeClass('highlighted');
                    container.find('.matching-arrow').removeClass('hidden');
                },
                revert(droppableContainer) {
                    if (droppableContainer) {
                        Postlogin.Lesson.playSoundEffect('correct');
                        // if drop is valid i.e. draggable is dropped on a valid droppable or droppable has accepted the draggable
                    } else {
                        Postlogin.Lesson.playSoundEffect('incorrect');
                        const $item = $(this);
                        $item.addClass('incorrect');
                        setTimeout(() => {
                            $item.removeClass('incorrect');
                        }, 1000);
                    }

                    return !droppableContainer; // returns true if invalid drop i.e draggable will revert and false if the draggable has been dropped correctly and thus no revert
                },
            });
        };

        me.makeDroppable = function (optionItem, optionId) {
            $(optionItem).droppable({
                accept: `.option-${optionId}`,
                drop() {
                    numberMatched++;

                    const feedbackTitle = me.options[optionId].feedback_title;
                    const feedbackAudio = me.options[optionId].feedback_audio;
                    const feedbackBody = me.getOptionFeedback(optionId);

                    if (feedbackBody) {
                        $('#beep-9-modal .content-container').addClass('correct');

                        // show the option-feedback modal window
                        Postlogin.Lesson.Popup.showModal({
                            title: feedbackTitle,
                            body: feedbackBody,
                            class: 'correct',
                            overlay: 'light',
                            smaller: true,
                            actions: [
                                {
                                    label: 'Continue',
                                    cssClass: 'btn-xl btn-success btn-continue',
                                    onClick(e) {
                                        e.stopPropagation();
                                        Postlogin.Lesson.pauseCurrentSound();
                                        if (numberOfOptions === numberMatched) {
                                            Postlogin.Lesson.Popup.showCompletionModal(me);
                                        } else {
                                            Postlogin.Lesson.Popup.hideModal();
                                        }
                                    },
                                },
                                {
                                    label: 'Replay <i class="fa fa-volume-up"></i>',
                                    cssClass: 'btn-replay-audio btn-default pull-left',
                                    onClick(e) {
                                        e.stopPropagation();
                                        $(this).fadeOut();
                                        Postlogin.Lesson.playSound(feedbackAudio, 0, null, () => {
                                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        });
                                    },
                                },
                            ],
                            onShow() {
                                $('#beep-9-modal .btn-replay-audio').fadeOut();
                                if (feedbackAudio) {
                                    if (
                                        Postlogin.Lesson.soundEnabled()
                                        && !$(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).hasClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        )
                                    ) {
                                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                                    }

                                    Postlogin.Lesson.playSound(feedbackAudio, 500, null, () => {
                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                                        $(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).addClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        );
                                    });
                                }
                            },
                            onHide() {
                                me.moveOptionBack(optionId);
                                $('#beep-9-modal .content-container').removeClass('correct');
                            },
                        });
                    } else {
                        Postlogin.Lesson.pauseCurrentSound();

                        if (feedbackAudio) {
                            Postlogin.Lesson.playSound(feedbackAudio, 500);
                        }

                        me.moveOptionBack(optionId);

                        if (numberOfOptions === numberMatched) {
                            setTimeout(() => {
                                Postlogin.Lesson.Popup.showCompletionModal(me);
                            }, 750);
                        }
                    }
                },
            });
        };

        me.replay = function (forceShowHelp = false) {
            numberMatched = 0;

            // unmark all items and move them back to their starting places
            $(container)
                .find('.collection .item')
                .each(function () {
                    $(this).removeClass('matched correct incorrect used');
                    $(this).animate(
                        {
                            top: 0,
                            left: 0,
                            opacity: 1,
                        },
                        {
                            duration: 600,
                            easing: 'easeOutBack',
                        },
                    );
                });

            // disable dragging
            $(container).find('.collection .item').draggable('disable');

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    $(container).find('.collection .item').draggable('enable');
                    if (me.completed && !me.last) {
                        Postlogin.Lesson.showNextButton();
                    }
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        me.resize = function () {};

        me.moveOptionBack = function (optionId) {
            $(`.item.option-${optionId}`).each(function () {
                $(this).draggable('disable');
                $(this).addClass('matched correct');

                // //fade these items out
                $(this).animate(
                    {
                        top: 0,
                        left: 0,
                        opacity: 0.3,
                    },
                    1000,
                    'easeInOutQuint',
                    function () {
                        $(this).addClass('correct used');
                    },
                );
            });
        };

        me.checkCompletion = function () {
            if (numberOfOptions === numberMatched) {
                setTimeout(() => {
                    Postlogin.Lesson.Popup.showCompletionModal(me);
                }, 750);
            }
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
